/* global $:false, toastr:false */
;(function () {
  'use strict'

  angular.module('admin.users.details.profile', []).controller('ProfileUserCtrl', ProfileUserCtrl)

  /** @ngInject */
  function ProfileUserCtrl(
    $scope,
    $rootScope,
    $state,
    $timeout,
    $stateParams,
    ProfileService,
    UploadService,
    UsersService,
  ) {
    var vm = this
    vm.path = false
    vm.file = ''
    vm.img = null
    vm.isOpen = false
    vm.oldEmail = ''

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    vm.openCalendar = function (e) {
      e.preventDefault()
      e.stopPropagation()

      vm.isOpen = true
    }

    UsersService.get($stateParams.parentId).then(function (result) {
      var model = result.results
      vm.id = model.id
      vm.oldEmail = model.email
      vm.email = model.email
      vm.phone = model.phone
      vm.username = model.username
      vm.oldUsername = model.username
      vm.name = model.name
      vm.bday = model.bday
      vm.blurb = model.blurb
      if (model.img === undefined) {
        vm.img = null
      } else {
        vm.img = model.img
      }

      if (model.bday !== undefined && model.bday !== 0 && model.bday !== null) {
        model.bday = model.bday.toString().substring(0, model.bday.toString().length - 3)
        vm.bday = new Date(parseInt(model.bday))
        var bday = moment(vm.bday).format('LL')

        vm.age = parseInt(moment(bday).format('LL').split(',')[1].trim())
        var year = new Date().getFullYear()
        var monthNow = new Date().getMonth()
        var monthUser = new Date(bday).getMonth()
        var dayNow = new Date().getDate()
        var dayUser = new Date(bday).getDate()
        if (vm.age < year) {
          vm.age = year - vm.age
        } else {
          vm.age = vm.age - year
        }

        if (monthUser > monthNow) {
          vm.age = vm.age - 1
        }

        if (monthUser === monthNow) {
          if (dayUser < dayNow) {
            vm.age = vm.age + 1
          }
        }
      }
    })

    vm.reload = function () {
      $state.go($state.current, {}, { reload: true })
    }

    vm.edit = function () {
      vm.editing = !vm.editing
    }

    vm.saveUsername = function () {
      swal(
        {
          title: 'Are you sure ?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.usernameAvailable(vm.username).then(function () {
              UsersService.changeUsername(vm.id, { username: vm.username }).then(function () {
                vm.oldUsername = vm.username
                swal.close()
                toastr.success('Username changed successfully')
              })
            })
          }
        },
      )
    }

    vm.saveEmail = function () {
      swal(
        {
          title: 'Are you sure ?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.changeEmail(vm.id, { email: vm.email }).then(function () {
              swal.close()
              toastr.success('Email changed successfully')
            })
          }
        },
      )
    }

    vm.savePhone = function () {
      swal(
        {
          title: 'Are you sure ?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.changePhone(vm.id, { phone: vm.phone }).then(function () {
              swal.close()
              toastr.success('Phone changed successfully')
            })
          }
        },
      )
    }

    vm.saveBirthdate = function () {
      swal(
        {
          title: 'Are you sure ?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            var bday = vm.bday
            if (bday !== undefined && bday !== '' && bday !== null) {
              if (isDate(bday)) {
                var date = parseInt(new Date(bday).getTime() + '000')
                bday = date
              } else {
                swal('Date field invalid.', '', 'error')
                return
              }
            }
            UsersService.birthday(vm.id, { bday: bday }).then(function () {
              swal.close()
              toastr.success('Birthdate changed successfully')
            })
          }
        },
      )
    }

    vm.save = function () {
      swal(
        {
          title: 'Are you sure ?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            UsersService.me(vm.id, { name: vm.name, blurb: vm.blurb }).then(function () {
              var bday = vm.bday
              if (bday !== undefined && bday !== '' && bday !== null) {
                if (isDate(bday)) {
                  var date = parseInt(new Date(bday).getTime() + '000')
                  bday = date
                } else {
                  swal('Date field invalid.', '', 'error')
                  return
                }
              }
            })
          } else {
            return
          }
        },
      )
    }

    vm.cancel = function () {
      vm.editing = !vm.editing
    }

    var watch = $scope.$watch('vm.file', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.path = false
        return
      }

      if (newVal === null) {
        vm.path = false
      }

      vm.path = true
      UploadService.save('users', newVal, 'img', vm.id).then(function (fileName) {
        vm.path = false
        vm.img = fileName
        UsersService.me(vm.id, { img: vm.img }).then(function () {})
      })
    })

    vm.back = function () {
      $state.go('admin.users.details', { id: vm.id })
    }

    $scope.$on('$destroy', function () {
      watch()
    })
  }
})()
